import { memo } from 'react'
import { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd'

import { Option } from 'components/elements/ArchidektDropdown/types'

import ImageCard from 'components/card/deckCards/imageCard'
import StackWrapper from 'components/deckPage/dragAndDrop/StackWrapper'
import StackHeader from 'components/deckPage/DeckContainerV2/StackHeader'

import styles from './imageStack.module.scss'
import { useAppSelector } from 'redux/hooks'

type Props = {
  cardIds: string[]
  name: string
  price: number
  quantity: number
  mdfcQuantity: number
  isPremier: boolean
  includedInDeck: boolean
  includeInPrice: boolean
  dragHandleProps?: DraggableProvidedDragHandleProps | null
  onDragTriggerMouseDown?: () => void
  onDragTriggerMouseUp?: () => void
  simplifiedDOMStack?: boolean
  hideSecondPrice?: boolean
  className?: string
  cardStackClassName?: string
  extraOptions?: Option[]
}

const Stack = memo(
  ({
    cardIds,
    name,
    price,
    quantity,
    mdfcQuantity,
    includedInDeck,
    includeInPrice,
    isPremier,
    dragHandleProps,
    onDragTriggerMouseDown,
    onDragTriggerMouseUp,
    simplifiedDOMStack,
    className = '',
    cardStackClassName = '',
    extraOptions,
  }: Props) => {
    const multiSelectedIds = useAppSelector(state => state.active.multiSelectedIds)
    const isMultiSelecting = Object.keys(multiSelectedIds).length

    return (
      <div className={`${styles.container} ${className}`}>
        <StackWrapper name={name} className={styles.center}>
          <StackHeader
            name={name}
            price={price}
            quantity={quantity}
            mdfcQuantity={mdfcQuantity}
            cardIds={cardIds}
            dragHandleProps={dragHandleProps}
            onDragTriggerMouseDown={onDragTriggerMouseDown}
            onDragTriggerMouseUp={onDragTriggerMouseUp}
            className={`${styles.stackHeader} ${!includedInDeck ? styles.maybeStack : ''}`}
            extraOptions={extraOptions}
            includeInDeck={includedInDeck}
            includeInPrice={includeInPrice}
            isPremier={isPremier}
          />
          <div
            className={`${styles.cardStack} ${isMultiSelecting || simplifiedDOMStack ? styles.adjustCardOffsetForMultiSelect : ''} ${cardStackClassName}`}>
            {cardIds.map((cardId, index) => (
              <ImageCard
                skipOpenOnClick
                simplifiedDOMStack={simplifiedDOMStack}
                hideControlsUnlessHovered={index !== cardIds.length - 1}
                cardId={cardId}
                key={`${cardId}-${index}`}
                stackName={name}
                className={styles.basicCard}
                basicCardClass={styles.basicCard}
                imageClassName={styles.cardImage}
              />
            ))}

            {!cardIds.length && <div className={styles.emptyStack}>Empty stack</div>}
          </div>
        </StackWrapper>
      </div>
    )
  },
)

export default Stack
